export enum Icons {
  ExpandLess = 'expand_less',
  ExpandMore = 'expand_more',
  Logout = 'logout',
}
